import { db } from '@/db/schema';
import { updateState } from '@/db/repositories/localSignState';
import type { Sign } from '@/types/catalog';

/** Registra a visualização de um sinal (F15-T03). */
export async function recordView(signId: string, at: Date = new Date()): Promise<void> {
  await updateState(signId, (current) => ({ ...current, lastViewedAt: at.toISOString() }));
}

export interface RecentEntry {
  sign: Sign;
  lastViewedAt: string;
}

/** Sinais vistos recentemente, do mais recente para o mais antigo. */
export async function listRecent(limit = 30): Promise<RecentEntry[]> {
  const rows = await db.localSignState
    .where('lastViewedAt')
    .above('')
    .reverse()
    .limit(limit)
    .toArray();

  const signs = await db.signs.bulkGet(rows.map((row) => row.signId));

  return rows
    .map((row, index) => ({ sign: signs[index], lastViewedAt: row.lastViewedAt ?? '' }))
    .filter((entry): entry is RecentEntry => entry.sign !== undefined);
}

export async function clearHistory(): Promise<void> {
  await db.transaction('rw', db.localSignState, async () => {
    const rows = await db.localSignState.toArray();
    await db.localSignState.bulkPut(
      rows.map((row) => {
        const { lastViewedAt: _dropped, ...rest } = row;
        return rest;
      }),
    );
  });
}
